export const TABLE_BOOKED_WARNING = 'This table is already booked at that time.';
export const TABLE_PARTY_WARNING = 'This table is already taken at that time.';

export function tableTakenWarning(isReservation: boolean): string {
  if (isReservation) {
    return TABLE_BOOKED_WARNING;
  }

  return TABLE_PARTY_WARNING;
}

export interface SaveAnywayOverrides {
  overrideNoResources?: boolean;
  overridePartySize?: boolean;
  overrideSeatedConflict?: boolean;
}

export interface SaveAnywayApproval {
  warning: string;
  overrides: SaveAnywayOverrides;
}

// One flag per prompt: the capacity warning approves overridePartySize, the booked
// overlap overrideNoResources. A seated occupant is never approved here; the server
// refuses it and its own seated-table prompt asks for overrideSeatedConflict.
export function buildSaveAnywayApproval(args: {
  resourceSizeAlert: string | null;
  overlap: boolean;
  allowMultipleParties: boolean;
  overlapWarning?: string;
}): SaveAnywayApproval | null {
  const { resourceSizeAlert, overlap, allowMultipleParties, overlapWarning = TABLE_BOOKED_WARNING } = args;
  if (!resourceSizeAlert && !overlap) {
    return null;
  }

  const warnings: string[] = [];
  const overrides: SaveAnywayOverrides = {};
  if (resourceSizeAlert) {
    warnings.push(resourceSizeAlert);
    overrides.overridePartySize = true;
    if (allowMultipleParties) {
      overrides.overrideNoResources = true;
    }
  }

  if (overlap) {
    warnings.push(overlapWarning);
    overrides.overrideNoResources = true;
  }

  return {
    warning: warnings.join(' '),
    overrides,
  };
}
